export enum ReducerNames {
  GLOBAL = 'global',
  CHARACTERS = 'characters',
  ENCOUNTERS = 'encounters',
  ENCOUNTER_PLAY = 'encounter_play',
}
